import React from "react";

import PageHeading from "2g-page-heading";

import { FixniPozadavkyBoxContent } from "b2b/components/fixni-pozadavky-box/FixniPozadavkyBoxContent";

const FAZE_OBDOBI_FIXNI = {
  openDay: "pondělí",
  openHours: "12",
  closeDay: "středa",
  closeHours: "08"
};

const FAZE_OBDOBI_VSECHNY = {
  openDay: "čtvrtek",
  openHours: "08",
  closeDay: "pátek",
  closeHours: "12"
};

export function FixniPozadavkyBoxContentExample() {
  return (
    <div>
      <PageHeading>Open fixni</PageHeading>
      <div data-testid="open-fixni">
        <FixniPozadavkyBoxContent
          loading={false}
          loaded
          error={false}
          fazeObdobiFixni={FAZE_OBDOBI_FIXNI}
          fazeObdobiVsechny={FAZE_OBDOBI_VSECHNY}
          faze={{
            fixni: true,
            vsechny: false
          }}
        />
      </div>
      <PageHeading>Open vsechny</PageHeading>
      <div data-testid="open-vsechny">
        <FixniPozadavkyBoxContent
          loading={false}
          loaded
          error={false}
          fazeObdobiFixni={FAZE_OBDOBI_FIXNI}
          fazeObdobiVsechny={FAZE_OBDOBI_VSECHNY}
          faze={{
            fixni: false,
            vsechny: true
          }}
        />
      </div>
      <PageHeading>Close</PageHeading>
      <div data-testid="close">
        <FixniPozadavkyBoxContent
          loading={false}
          loaded
          error={false}
          fazeObdobiFixni={FAZE_OBDOBI_FIXNI}
          fazeObdobiVsechny={FAZE_OBDOBI_VSECHNY}
          faze={{
            fixni: false,
            vsechny: false
          }}
        />
      </div>
      <PageHeading>Loading</PageHeading>
      <div data-testid="loading">
        <FixniPozadavkyBoxContent
          loading
          loaded={false}
          error={false}
          fazeObdobiFixni={FAZE_OBDOBI_FIXNI}
          fazeObdobiVsechny={FAZE_OBDOBI_VSECHNY}
          faze={{
            fixni: false,
            vsechny: false
          }}
        />
      </div>
      <PageHeading>Error</PageHeading>
      <div data-testid="error">
        <FixniPozadavkyBoxContent
          loading={false}
          loaded={true}
          error="Chybička se vloudila"
          fazeObdobiFixni={FAZE_OBDOBI_FIXNI}
          fazeObdobiVsechny={FAZE_OBDOBI_VSECHNY}
          faze={{
            fixni: false,
            vsechny: false
          }}
        />
      </div>
    </div>
  );
}

FixniPozadavkyBoxContentExample.propTypes = {};

export default React.memo(FixniPozadavkyBoxContentExample);
